// import axios from "axios";


// const GetEmployeeList = async () => {
//   return axios.get(`EMP/GetEmployees`).then((response) => response);
// };


// const GetEmployeeAddresses = async (employeeId) => {
//   return axios.get(`EMP/GetAddressEmployeebyID`, {
//     params: {
//       p_hedEmployeeId: employeeId
//     }
//   })
//   .then((response) => response);
// };

// const GetEmployeeQualifications = async (employeeId) => {
//   return axios.get(`EMP/GetEduEmployeebyID`, {
//     params: {
//       p_hedEmployeeId: employeeId
//     }
//   })
//   .then((response) => response);
// };


// const AddEmployee = async (payload) => {
//   const isFormData = typeof FormData !== "undefined" && payload instanceof FormData;
 
//   if (isFormData) {
//     console.log("Data being submitted to addEmployee (FormData entries):");
//     for (const [key, value] of payload.entries()) {
//       console.log(" -", key, ":", value instanceof File ? `File(${value.name}, ${value.size} bytes)` : value);
//     }
//   } else {
//     console.log("Data being submitted to addEmployee:", payload);
//   }
 
//   const config = {
//     method: "post",
//     url: `EMP/AddEmployee`,
//     data: payload,
//   };
 
//   if (isFormData) {
 
//     config.transformRequest = (data) => data; 
//   } else {
//     config.headers = { "Content-Type": "application/json" };
//   }
 
//   return axios.request(config).then((response) => response);
// };
 


// const AddEmployeeAddress = (params) =>
//   axios.post(`EMP/AddEmployeeAddress`, null, { params }).then((res) => res);

// const AddEmployeeQualification = (payload) =>
//   axios
//     .request({
//       method: "post",
//       url: "EMP/AddEmployeeEducation",
//       headers: { "Content-Type": "application/json" },
//       data: payload,
//     })
//     .then((res) => res);


// const UpdateEmployee = async (payload) => {
//   const config = {
//     method: "post",
//     url: `EMP/UpdateEmployee`,
//     headers: { "Content-Type": "application/json" },
//     data: payload,
//   };
//   return axios.request(config).then((response) => response);
// };

// const AddBankDetails = (params) =>
//   axios.get(`EMP/AddBankDetails`, { params }).then((res) => res);

// const UploadEmployeeDocs = (employeeNo, formData) =>
//   axios.post(`EMP/UploadEmployeeDocs`, formData, {
//     params: { employeeNo },
//     headers: { "Content-Type": "multipart/form-data" },
//   }).then((res) => res);

// const UpdateEmployeeAddress = (params) => 
//     axios.post(`EMP/UpdateEmployeeAddress`, null, { params }).then((res) => res);

// const UpdateEmployeeEdu = (params) => 
//     axios.post(`EMP/UpdateEmployeeEdu`, null, { params }).then((res) => res);

// const employeeService = {
//   GetEmployeeList,
//   AddEmployee,
//   UpdateEmployee,
//   AddEmployeeAddress,
//   AddEmployeeQualification,
//   AddBankDetails,
//   UploadEmployeeDocs,
//   GetEmployeeAddresses,
//   GetEmployeeQualifications,
//   UpdateEmployeeAddress,
//   UpdateEmployeeEdu,
// };

// export default employeeService;





import axios from "axios";

const GetEmployeeList = async () => {
  return axios.get(`EMP/GetEmployees`).then((response) => response);
};

const GetEmployeeAddresses = async (employeeId) => {
  return axios.get(`EMP/GetAddressEmployeebyID`, {
    params: { p_hedEmployeeId: employeeId }
  }).then((response) => response);
};

const GetEmployeeQualifications = async (employeeId) => {
  return axios.get(`EMP/GetEduEmployeebyID`, {
    params: { p_hedEmployeeId: employeeId }
  }).then((response) => response);
};

const GetEmployeeBankDetails = async (employeeId) => {
  return axios.get(`EMP/GetBankDetails`, {
    params: { p_hedEmployeeId: employeeId }
  }).then((response) => response);
};

const GetEmployeeContacts = async (employeeId) => {
  return axios.get(`EMP/GetEmployeeContacts`, {
    params: { p_hedEmployeeId: employeeId }
  }).then((response) => response);
};

const AddEmployee = async (payload) => {
  const isFormData = typeof FormData !== "undefined" && payload instanceof FormData;
  
  if (isFormData) {
    console.log("Data being submitted to addEmployee (FormData entries):");
    for (const [key, value] of payload.entries()) {
      console.log(" -", key, ":", value instanceof File ? `File(${value.name}, ${value.size} bytes)` : value);
    }
  } else {
    console.log("Data being submitted to addEmployee:", payload);
  }
  
  const config = {
    method: "post",
    url: `EMP/AddEmployee`,
    data: payload,
  };
  
  if (isFormData) {
    config.transformRequest = (data) => data;
  } else {
    config.headers = { "Content-Type": "application/json" };
  }
  
  return axios.request(config).then((response) => response);
};

const AddEmployeeAddress = (params) =>
  axios.post(`EMP/AddEmployeeAddress`, null, { params }).then((res) => res);

const AddEmployeeQualification = (payload) =>
  axios.request({
    method: "post",
    url: "EMP/AddEmployeeEducation",
    headers: { "Content-Type": "application/json" },
    data: payload,
  }).then((res) => res);

const UpdateEmployee = async (payload) => {
  const config = {
    method: "post",
    url: `EMP/UpdateEmployee`,
    headers: { "Content-Type": "application/json" },
    data: payload,
  };
  return axios.request(config).then((response) => response);
};
 
const UpdateEmployeeBank = async (params) => {
  return axios.get(`EMP/UpdateEmployeeBank`, { params })
    .then((response) => response);
};
 
const AddEmployeeContact = (params) =>
  axios.get(`EMP/AddEmployeeContact`, { params })
  .then((response) => response);

const UpdateEmployeeContact = async (params) => {
  return axios.get(`EMP/UpdateEmployeeContact`, { params })
    .then((response) => response);
}; 
const UpdateEmployeeAddress = (params) => 
  axios.post(`EMP/UpdateEmployeeAddress`, null, { params }).then((res) => res);
 
const UpdateEmployeeEdu = (params) => 
  axios.post(`EMP/UpdateEmployeeEdu`, null, { params }).then((res) => res);

const AddBankDetails = (params) =>
  axios.get(`EMP/AddBankDetails`, { params }).then((res) => res);

const UploadEmployeeDocs = (employeeNo, formData) =>
  axios.post(`EMP/UploadEmployeeDocs`, formData, {
    params: { employeeNo },
    headers: { "Content-Type": "multipart/form-data" },
  }).then((res) => res);
 
const DeleteEmployeeBank = async (employeeBankId) => {
  return axios.get(`EMP/DeleteEmployeeBank`, {
    params: { p_hebEmployeeBankId: employeeBankId }
  }).then((response) => response);
};
 
const DeleteEmployeeContact = async (contactId) => {
  return axios.get(`EMP/DeleteEmployeeContact`, {
    params: { p_hecContactId: contactId }
  }).then((response) => response);
};

const employeeService = {
  GetEmployeeList,
  AddEmployee,
  UpdateEmployee,
  AddEmployeeAddress,
  AddEmployeeQualification,
  AddBankDetails,
  UploadEmployeeDocs,
  GetEmployeeAddresses,
  GetEmployeeQualifications,
  GetEmployeeBankDetails,
  GetEmployeeContacts,
  UpdateEmployeeAddress,
  UpdateEmployeeEdu,
  UpdateEmployeeBank,
  UpdateEmployeeContact,
  AddEmployeeContact,
  DeleteEmployeeBank,
  DeleteEmployeeContact,
};

export default employeeService;